import { render, staticRenderFns } from "./PrivecyPolicy.vue?vue&type=template&id=207e0e52&scoped=true"
import script from "./PrivecyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivecyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivecyPolicy.vue?vue&type=style&index=0&id=207e0e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e0e52",
  null
  
)

export default component.exports